"use client";
import { useDispatch } from "react-redux";
import { deleteShop } from "@/state/shops/shop.slice";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export default function DeleteShopDialog({ isOpen, onClose, shop }) {
  const dispatch = useDispatch();

  const handleDelete = async () => {
    if (shop) {
      await dispatch(deleteShop(shop._id));
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Shop</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete {shop?.name}? This action cannot be
            undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={handleDelete}>
            Delete Shop
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
